import styled from 'styled-components';

export const InfoContainer = styled.div`
  margin-top: ${props => props.theme.spacing(6)};
  display: grid;
  gap: ${props => props.theme.spacing(4)};
  grid-template-columns: repeat(1, auto);
  @media ${props => props.theme.laptop} {
    grid-template-columns: repeat(2, auto);
  }
`;
